import { render, staticRenderFns } from "./DatasetError.vue?vue&type=template&id=2a35d0d9"
import script from "./DatasetError.vue?vue&type=script&setup=true&lang=ts"
export * from "./DatasetError.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports